<res-base-modal [modalTitle]="'Generate Data Set Report'" [modalClass]="modalClass" [modalAutomationId]="automationId"
    [primaryButtonLabel]="'Generate Data Set Report'" (primaryButtonActionEmt)="generateReport()"
    (closeButtonActionEmt)="closeModal()" [isPrimaryBtnEnabled]="!isBusy"
    [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
    [modalHelpIndex]="modalHelpIndex">

    <div class="modal-row">
        <label class="modal-label">Report Settings:</label>
        <select name="reportSettings" [attr.data-automation-id]="automationId + '-report-settings-dropdown'"
            [(ngModel)]="selectedReportSetting" class="report-settings-dropdown">
            <option *ngFor="let setting of reportSettings" [value]="setting.value">{{setting.label}}</option>
        </select>
    </div>

    <div class="modal-row">
        <res-custom-checkbox [attr.data-automation-id]="automationId + '-combine-warnings-errors-checkbox'"
            [(ngModel)]="combineWarningsAndErrors"
            content="Combine Warnings & Errors with Custom Warnings & Errors">
        </res-custom-checkbox>
    </div>

    <div class="modal-row">
        <res-custom-checkbox [attr.data-automation-id]="automationId + '-include-zero-count-rows-checkbox'"
            [(ngModel)]="includeZeroCountRows"
            content="Include Zero-Count Rows">
        </res-custom-checkbox>
    </div>

    <div class="modal-row">
        <res-custom-checkbox [attr.data-automation-id]="automationId + '-include-percentages-checkbox'"
            [(ngModel)]="includePercentages"
            content="Include Percentages">
        </res-custom-checkbox>
    </div>

</res-base-modal>
